import { STORES_ID } from "./stores";

export const getThemeVariables = (storeId) => {
	switch (storeId) {
		case STORES_ID["310"]:
		case STORES_ID["312"]:
		case STORES_ID["321"]:
		case STORES_ID["324"]:
		case STORES_ID["344"]:
			return {
				mainColor: "#f8b912",
				primaryBackgroundHover: "#fac742",
				primaryBackgroundActive: "#ebb000",
			};

		case STORES_ID["318"]:
		case STORES_ID["325"]:
			return {
				mainColor: "#ea6a20",
				primaryBackgroundHover: "#f56722",
				primaryBackgroundActive: "#db631e",
			};
		default:
			return {
				mainColor: "#f8b912",
				primaryBackgroundHover: "#fac742",
				primaryBackgroundActive: "#ebb000",
			};
	}
};
